import {Determinant} from "./determinant";
import {Requirement} from "./requirement";
import {DocumentRequirementField} from "./document-requirement_field";
import {Bot} from "./bot";

export class DocumentRequirement {

  public id: string;
  public registrationId: string;
  public requirement: Requirement;
  public determinants: Determinant[];
  public bot: Bot;
  public requirementId: string;
  public toUpload: boolean = true;
  public toShow: boolean;
  public toSign: boolean;
  public multiple: boolean;
  public toPrintUpload: boolean;
  public alternative: boolean;
  public additionalInformation: string;
  public alternativeGroup: string;
  public jsonDeterminants: string;
  public linkingFileUploadPath: string;
  public linkingFileUploadPathRouterLink: string;
  public linkingFileUploadPathTitle: string;
  public usedAsADatabase: boolean = false;
  public templateUrl: string;
  public aiSchemaName: string;
  public aiSchemaDescription: string;
  public fields: DocumentRequirementField[] = [];

  get name(): string {
    return this.requirement ? this.requirement.name : "";
  }
}
